import { FormControl } from '@angular/forms';
import { OrganizationalUnit } from '../organizational-units/organizationalUnit';
import { ConflictSetting } from './shift-plan.interface';

export const RangeShorterThanPlanDaysError = 'range_shorter_than_plan_days';

export interface HeaderForm {
  [HeaderFormKeys.Name]: FormControl<string>;
  [HeaderFormKeys.DateRange]: FormControl<[Date, Date]>;
  [HeaderFormKeys.Rolling]: FormControl<boolean>;
  [HeaderFormKeys.ConflictSetting]: FormControl<ConflictSetting>;
  [HeaderFormKeys.OrgUnit]: FormControl<string>;
}

export enum HeaderFormKeys {
  Name = 'name',
  DateRange = 'dateRange',
  Rolling = 'rolling',
  ConflictSetting = 'conflictSetting',
  OrgUnit = 'orgUnit',
}
